module.exports = __webpack_public_path__ + "img/zoe_estates_bg_001.8ace1aab.jpg";